import Model from 'src/storage/base';

class SettingModel extends Model {
  id = 'settings';
  persistent = false;
  defaultState = () => ({});

  _events = {
    profile: 'handleChangeProfileAndSwitchAccount'
  };
}

const model = new SettingModel();
export default model;
